import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const ImageIconWrapper = styled(Box)(`
  width: 32px;
  height: 32px;
  border: 1px solid  #D8D8D6;
  border-radius: 50%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  position: relative;
  text-transform: uppercase;
  overflow:hidden;

  &.large {
    width: 64px;
    height: 64px;
  }
  
  & span{
  }

  & img {
    width: 100%;
    position: absolute;
    z-index: 1;
    left:0;
    background: #fff;
  }

  &.imageNotLoaded {
    background: #F6F6F5;
    img {display: none;}
    span {display: block; }
  }
`)
